import { render, staticRenderFns } from "./userSetting.vue?vue&type=template&id=f4c97a9a&scoped=true"
import script from "./userSetting.vue?vue&type=script&lang=js"
export * from "./userSetting.vue?vue&type=script&lang=js"
import style0 from "./userSetting.vue?vue&type=style&index=0&id=f4c97a9a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4c97a9a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\space\\tops\\tops-front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f4c97a9a')) {
      api.createRecord('f4c97a9a', component.options)
    } else {
      api.reload('f4c97a9a', component.options)
    }
    module.hot.accept("./userSetting.vue?vue&type=template&id=f4c97a9a&scoped=true", function () {
      api.rerender('f4c97a9a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/settings/userSetting.vue"
export default component.exports